module.exports = __webpack_public_path__ + "static/media/Stage_name_2_line.bc96a0ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Stage_name_2_line.gif
// module id = 200
// module chunks = 0